import React, { useContext } from 'react';
import CbmContext from '../../Context/Cbm/cbmContext';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../../Services/authService';

function RestrictedRoutes({ children }) {
  const cbmContext = useContext(CbmContext);
  const { auth } = cbmContext;
  const location = useLocation();

  const shouldLogout = authService.shouldLogout();

  return auth ? (
    children
  ) : shouldLogout ? (
    <Navigate to="/logout" />
  ) : (
    <Navigate
      to={`/login?returnTo=${encodeURIComponent(
        `${location.pathname}${location.search}${location.hash}`
      )}`}
      replace
    />
  );
}

export default RestrictedRoutes;
